import { createPortal } from 'react-dom';

interface IPortalProps {
  children: React.ReactNode;
}

const Portal = ({ children }: IPortalProps) => createPortal(children, document.body);

export default Portal;
